import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import { Dispatch, SetStateAction, SyntheticEvent } from 'react';
import { AlertColor } from '@mui/material/Alert/Alert';

interface SnackbarComponentProps {
  message?: string;
  open: boolean;
  severity: AlertColor;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const SnackbarComponent = ({
  message,
  setOpen,
  severity,
  open,
}: SnackbarComponentProps) => {
  const handleClose = (
    event?: SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar
      sx={{ zIndex: 99999999 }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
